import type { SearchKeyValueParam } from '../../types';
import { getMetadataFieldValue } from '../../utils';
import { DEAKIN_FUNNELBACK_COLLECTION, DEAKIN_FUNNELBACK_PROFILE } from '../../funnelback/deakin-config';
import { resolveFunnelbackUrlsFromMeta } from '../../funnelback/funnelback-base-url';

function defaultSuggestExtras(collectionId: string): SearchKeyValueParam[] {
  const out: SearchKeyValueParam[] = [
    { key: 'fmt', value: 'json++' },
    { key: 'alpha', value: '0.5' },
    { key: 'profile', value: '_default_preview' },
    { key: 'num_ranks', value: '9' },
  ];
  if (collectionId) {
    out.push({ key: 'collection', value: collectionId });
  }
  return out;
}

export type SearchRuntimeConfig = {
  lookupBaseUrl: string;
  suggestBaseUrl: string;
  collectionId: string;
  pageSize?: number;
  lookupExtras: SearchKeyValueParam[];
  suggestExtras: SearchKeyValueParam[];
};

export function resolveSearchRuntimeConfig(
  _pageUrlPath: string,
): SearchRuntimeConfig {
  const { lookupBaseUrl, suggestBaseUrl } = resolveFunnelbackUrlsFromMeta();
  const collectionIdFromMeta = getMetadataFieldValue(
    'funnelbackCollectionId',
  ).trim();
  const searchCollectionOverride = getMetadataFieldValue(
    'searchFunnelbackCollectionId',
  ).trim();
  const collectionId =
    searchCollectionOverride ||
    collectionIdFromMeta ||
    DEAKIN_FUNNELBACK_COLLECTION;

  const funnelbackProfile = getMetadataFieldValue('funnelbackProfile').trim();
  const lookupProfile =
    getMetadataFieldValue('funnelbackLookupProfile').trim() ||
    DEAKIN_FUNNELBACK_PROFILE;
  const pageSizeMeta = getMetadataFieldValue('searchPageSize').trim();
  const parsedPageSize = Number.parseInt(pageSizeMeta, 10);
  const pageSize =
    Number.isFinite(parsedPageSize) && parsedPageSize > 0
      ? parsedPageSize
      : undefined;

  const lookupExtras: SearchKeyValueParam[] = [
    { key: 'collection', value: collectionId },
    { key: 'profile', value: lookupProfile },
  ];
  if (funnelbackProfile) {
    lookupExtras.push({ key: 'profile', value: funnelbackProfile });
  }
  const suggestExtras = defaultSuggestExtras(collectionId);

  return {
    lookupBaseUrl,
    suggestBaseUrl,
    collectionId,
    ...(pageSize != null ? { pageSize } : {}),
    lookupExtras,
    suggestExtras,
  };
}
